/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseJobListingFragment, JobListingFragment, FullJobListingFragment} from '@amblique/contentful/app/contentful/fragments/job-listing';

/**
 * Get a single JobListing by ID (base - scalars only)
 */
export const getBaseJobListingById = gql`
  ${BaseJobListingFragment}

  query GetBaseJobListingById($id: String!, $locale: String!, $preview: Boolean) {
    jobListing(id: $id, locale: $locale, preview: $preview) {
      ...BaseJobListingFragment
    }
  }
`;

/**
 * Get a single JobListing by ID (standard - 1 level deep)
 */
export const getJobListingById = gql`
  ${JobListingFragment}

  query GetJobListingById($id: String!, $locale: String!, $preview: Boolean) {
    jobListing(id: $id, locale: $locale, preview: $preview) {
      ...JobListingFragment
    }
  }
`;

/**
 * Get a single JobListing by ID (full - 2 levels deep)
 */
export const getFullJobListingById = gql`
  ${FullJobListingFragment}

  query GetFullJobListingById($id: String!, $locale: String!, $preview: Boolean) {
    jobListing(id: $id, locale: $locale, preview: $preview) {
      ...FullJobListingFragment
    }
  }
`;

/**
 * Get all JobListing entries with pagination (base - scalars only)
 */
export const getBaseJobListings = gql`
  ${BaseJobListingFragment}

  query GetBaseJobListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [JobListingOrder]
    $where: JobListingFilter
    $preview: Boolean
  ) {
    jobListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseJobListingFragment
      }
    }
  }
`;

/**
 * Get all JobListing entries with pagination (standard - 1 level deep)
 */
export const getJobListings = gql`
  ${JobListingFragment}

  query GetJobListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [JobListingOrder]
    $where: JobListingFilter
    $preview: Boolean
  ) {
    jobListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...JobListingFragment
      }
    }
  }
`;

/**
 * Get all JobListing entries with pagination (full - 2 levels deep)
 */
export const getFullJobListings = gql`
  ${FullJobListingFragment}

  query GetFullJobListings(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [JobListingOrder]
    $where: JobListingFilter
    $preview: Boolean
  ) {
    jobListingCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullJobListingFragment
      }
    }
  }
`;
